import { render, staticRenderFns } from "./getapi.vue?vue&type=template&id=512a51b6"
import script from "./getapi.vue?vue&type=script&lang=js"
export * from "./getapi.vue?vue&type=script&lang=js"
import style0 from "./getapi.vue?vue&type=style&index=0&id=512a51b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports